import { render, staticRenderFns } from "./TableViewImg.vue?vue&type=template&id=152d8a6c"
import script from "./TableViewImg.vue?vue&type=script&lang=js"
export * from "./TableViewImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports